import { render } from "./Verify.vue?vue&type=template&id=27228c75"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=27228c75&lang=css"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__